import React from 'react';
import { SelectOption } from 'global';
import { useFormContext, useWatch } from 'react-hook-form';
import { AutocompleteField, InputField } from 'components/form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { FinanceFormValues } from '../types';

export const FinanceExistingProgramFields = ({
  isFPOptionsLoading,
  financeProgramOptions,
  onFetchFinanceProgram,
}: {
  isFPOptionsLoading: boolean;
  financeProgramOptions: SelectOption[];
  onFetchFinanceProgram: (programId: string) => Promise<Partial<FinanceFormValues['financeQuote']>>;
}) => {
  const { control, setValue } = useFormContext<FinanceFormValues>();
  const program = useWatch({ control, name: 'financeQuote.program' });

  return (
    <>
      <AutocompleteField
        control={control}
        name="financeQuote.program"
        isLoading={isFPOptionsLoading}
        options={financeProgramOptions}
        disabled={!financeProgramOptions.length}
        textFieldProps={{ label: 'Select Program' }}
        extraAction={nextValue => {
          if (typeof nextValue?.value !== 'string') return;
          onFetchFinanceProgram(nextValue.value).then(value => {
            if (value) {
              Object.entries(value).forEach(([key, fieldValue]) => {
                setValue(`financeQuote.${key}` as any, fieldValue);
              });
            }
          });
        }}
      />

      <RenderWithCondition condition={!!program}>
        <InputField control={control} label="Finance Program Name" name="financeQuote.programName" />
      </RenderWithCondition>
    </>
  );
};
